module.exports = __webpack_public_path__ + "static/media/icon_add.540d79f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_add.svg
// module id = 320
// module chunks = 0